import {
  DisplayFormErrors,
  InputField,
  EfsMelcoEfsModelsFormat,
  VerticalForm,
  DebugForm,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { ColumnInputFormatDetailForm } from "./ColumnInputFormatDetailForm";
import { DataAssignments } from "./DataAssignments";
import { FilenameRules } from "./FilenameRules";
import { XMLInputFormatDetailForm } from "./XMLInputFormatDetailForm";

type DisplayInputFormatDetailFormProps = {
  inputFormat: EfsMelcoEfsModelsFormat;
};

export const DisplayInputFormatDetailForm: React.FC<
  DisplayInputFormatDetailFormProps
> = ({ inputFormat }) => {
  const { key } = inputFormat;

  const { t } = useTranslation();

  return (
    <>
      <VerticalForm>
        <DisplayFormErrors />

        <InputField
          name="display_name"
          label={t("inputFormats.detail.form.label.display_name")}
        />

        {key === "XML" ? (
          <XMLInputFormatDetailForm />
        ) : (
          <ColumnInputFormatDetailForm />
        )}

        <DataAssignments inputFormat={inputFormat} />

        <FilenameRules inputFormat={inputFormat} />
      </VerticalForm>

      {false && <DebugForm />}
    </>
  );
};
